export const FETCH_CHECKBOX_FILTER_REQUEST = 'FETCH_CHECKBOX_FILTER_REQUEST';
export const FETCH_CHECKBOX_FILTER_SUCCESS = 'FETCH_CHECKBOX_FILTER_SUCCESS';
export const FETCH_CHECKBOX_FILTER_FAILURE = 'FETCH_CHECKBOX_FILTER_FAILURE';
